import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from '../interfaces';
import classNames from 'classnames';
import * as he from 'he';
import { formatInTimeZone } from 'date-fns-tz';
import { DateTime } from 'luxon';

interface AnEventProps {
  event: App.EventListing;
  onClick: (event: App.EventListing) => void;

}

export class AnEvent extends React.Component<AnEventProps, undefined> {

  handleEventClick() {

    if (this.props.onClick) { this.props.onClick(this.props.event) };

  }

  

  render() {

    const classes = ['an-event__contained-event', 'an-event'];

    let startTime = null;

    const { start_time, title } = this.props.event.calendarItem;

    startTime = DateTime.fromJSDate(start_time).toFormat('h:mm a');    

    return <div onClick={e => this.handleEventClick()} className={classNames(classes)}>

      <div className={'an-event__wrap'}>
        <div className={'an-event__time'}>{ startTime }</div>
        <div className={'an-event__title'}>{ he.decode(title) }</div>
      </div>

    </div>
  }

}


// WEBPACK FOOTER //
// ./resources/src/components/schedule/an-event.tsx